

//DOM loaded
document.addEventListener("DOMContentLoaded", () => {

    //Listen to close button
    document.querySelectorAll('.pdw-megamenu-mobile-open').forEach((el) => {
        el.addEventListener('click', (ev) => {
            let el = document.getElementById(ev.target.dataset.target);
            el.classList.add('show');
        });
    });

    document.querySelectorAll('.pdw-megamenu-mobile-close').forEach((el) => {
        el.addEventListener('click', (ev) => {
            let el = document.getElementById(ev.target.dataset.target);
            el.classList.remove('show');
        });
    });


});
